// tslint:disable:max-classes-per-file

import classNames from "classnames";
import React from "react";
import { actions, Control } from "react-redux-form";
import _ from "underscore";

import { Errors } from "../../../../core/atoms/rrf";
import { ActionPromises } from "../../../state/actionPromises";
import { CommonProps, EnquiryFormSection, Validators } from "./common";
import { FormProgressIcon } from "./formProgressIcon";

import "./currencySelect.scss";

const required = Validators.required;

interface CurrencySelectProps {
  currencies: IBaseCurrency[];
  dispatch: any;
}

type Props = CommonProps & CurrencySelectProps;

class CurrencyCheckBox extends React.Component<{ currency: IBaseCurrency; }> {
  public render() {
    const { currency, ...inputProps } = this.props;

    return (
      <label className="rrf-currency-check-box" title={`Click to choose ${currency.name} as your currency`}>
        <input value={currency.id} {...inputProps} />
        <img src={`/images/flags/currency/${currency.code}.png`} alt={`${currency.name} country flag`} />
        <p>{currency.code}</p>
      </label>
    );
  }
}

export class CurrencySelect extends EnquiryFormSection<CurrencySelectProps> {

  private onCurrencySelect = (currency: IBaseCurrency) => {
    // Update the redux store so the budget question changes.
    this.props.dispatch(ActionPromises.changeCurrency(currency));
  }

  protected shouldUpdateValidity(oldProps: Props, newProps: Props) {
    return !_.isEqual(oldProps.formState.currencyId, newProps.formState.currencyId);
  }

  protected syncValidity(formState: Forms.EnquiryForm) {
    this.props.dispatch(actions.setErrors(this.props.model, { required: formState.currencyId == null }));
  }

  public render() {
    const { model, className, id, dispatch } = this.props;

    return (
      <section id={id} className={classNames("currency-selector", className)}>
        <header>
          <FormProgressIcon model={model} />
          <h2>Which currency would you like your quote to be in?</h2>
        </header>
        <div className="enquiry-form-question">
          <Errors model={model} messages={{ required: "Please choose your currency" }} />

          <div className="currencies-wrap">
            {this.props.currencies.map(currency =>
              <Control.radio
                key={currency.id}
                model={this.props.model}
                component={CurrencyCheckBox}
                controlProps={{ currency }}
                value={currency.id}
                getValue={e => parseInt((e as React.ChangeEvent<HTMLInputElement>).target.value, 10)}
                onChange={() => this.onCurrencySelect(currency)}
              />,
            )}
          </div>
        </div>
      </section>
    );
  }
}
